import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddDocument() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/DocumentLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Document Type"
      alert="Document Added Successfully"
      addDataAPIEndpoint="/DocChecklist/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Document Type",
              name: "DC_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "DC_Status",
              required: true, // Validation rule added here           
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        DC_Name: {
          required: true,
          
        },
        DC_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddDocument;
